import { Badge, Typography } from "@mui/material"

const BADGE_BASE_STYLE = {
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "10px"
};

const TEXT_BASE_STYLE = {
    color: "#000000",
    fontSize: "11px"
};

export const getClubLinksCampaignColumns = () => [
    {
        field: "date",
        headerName: "Date",
        width: 90,
        renderCell: ({ row }) => {
            const _id = row?._id;

            return (
                <Badge
                    sx={{
                        ...BADGE_BASE_STYLE,
                        backgroundColor: "#6c757d",
                        color: "#FFFFFF"
                    }}
                >
                    {new Date(parseInt(_id.substring(0, 8), 16) * 1000).toLocaleDateString("en-IN")}
                </Badge>
            )
        }
    },
    {
        field: "campaignName",
        headerName: "Campaign",
        width: 200,
        renderCell: ({ row }) => {
            const name = row?.name;

            return (
                <Typography
                    sx={TEXT_BASE_STYLE}
                >
                    {name}
                </Typography>
            )
        }
    },
    {
        field: "createdBy",
        headerName: "Created By",
        width: 200,
        renderCell: ({ row }) => {
            const pocName = row?.createdby?.fullName;

            return (
                <Typography
                    sx={TEXT_BASE_STYLE}
                >
                    {pocName}
                </Typography>
            )
        }
    }
]